export class AttachmentsHelper {
    static getUrl(link: string, blob: string, defaultContainer: string) {
        if (!link) {
            return "";
        }
        if (link.indexOf('/') == -1 && defaultContainer) {
            link = defaultContainer + '/' + link;
        }
        
        const container = blob.toString().replace(location.origin, '');
        if (link.indexOf(container) >= 0) {
            return link.indexOf('//') > 0 ? link.replace(/([^:])(\/\/+)/g, '$1/') : (link.indexOf('/') == -1 ? '/' + link : link);
        } else {

            if (link[0] == '/') {
                return blob + link;
            }
            else {
                return blob + '/' + link;
            }
        }
    }
}
